<template>
  <div
    class="ats-hero-bg"
    :class="{ 'is-ready': bgReady }"
    :style="bgStyle"
    role="presentation"
    aria-hidden="true"
  />
</template>

<script>
import { isImagePreloaded, preloadImage } from '@/util/atsImagePreload'

/**
 * 首屏背景：预加载完成后再绘制，避免 keep-alive 切换时背景闪白
 */
export default {
  name: 'AtsHeroBackground',
  props: {
    /** @type {string} 背景图地址 */
    src: {
      type: String,
      required: true
    },
    /** @type {string} background-position */
    position: {
      type: String,
      default: 'center center'
    },
    /** @type {string} background-size */
    size: {
      type: String,
      default: 'cover'
    },
    /** @type {string} 图片加载前的占位色 */
    fallbackColor: {
      type: String,
      default: '#0c1824'
    }
  },
  data () {
    return {
      /** @type {boolean} 背景图是否已解码可绘制 */
      bgReady: false
    }
  },
  computed: {
    /** @returns {{ backgroundImage: string, backgroundPosition: string, backgroundSize: string, backgroundColor: string }} */
    bgStyle () {
      return {
        backgroundImage: this.bgReady && this.src ? `url(${this.src})` : 'none',
        backgroundPosition: this.position,
        backgroundSize: this.size,
        backgroundColor: this.fallbackColor
      }
    }
  },
  watch: {
    src: {
      immediate: true,
      handler (src) {
        this.ensureBgReady(src)
      }
    }
  },
  activated () {
    this.ensureBgReady(this.src)
  },
  methods: {
    /**
     * 确认背景图已预加载/解码后再显示
     * @param {string} src
     * @returns {void}
     */
    ensureBgReady (src) {
      if (!src) {
        this.bgReady = false
        return
      }
      if (isImagePreloaded(src)) {
        this.bgReady = true
        return
      }
      this.bgReady = false
      preloadImage(src).then(() => {
        if (this.src === src) {
          this.bgReady = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ats-hero-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-repeat: no-repeat;
  pointer-events: none;
  transform: translateZ(0);
  backface-visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/ats/AtsHeroBackground.vue